module.exports = __webpack_public_path__ + "static/media/edit.99ee4b58.svg";